<template>
  <div class="tops">
    <img src="../assets/callbg.png" alt="">
    <h2>联系我们</h2>
  </div>
  <div class="centers">
    <div class="boxs1">
      <p class="title">感谢您对我们的关注。如果您有任何问题，请填写下方表单的资料，我们将第一时间与您联系。</p>
      <p><span>*</span> 为必填字段</p>
    </div>
    <div class="boxs2">
      <ul>
        <form>
          <li>
          <p>姓氏 <span>*</span></p>
          <input type="text" v-model="forms.famlyNames">
        </li>
        <li>
          <p>名字 <span>*</span></p>
          <input type="text" v-model="forms.Names">
        </li>
        <li>
          <p>电邮 <span>*</span></p>
          <input type="text" v-model="forms.Eml">
        </li>
        <li>
          <p>电话号码 </p>
          <input type="text" v-model="forms.Phones">
        </li>
        <li>
          <p>您想了解的产品或需求 <span>*</span></p>
          <textarea v-model="forms.Texts">666</textarea>
        </li>
        <div class="btns hovers" @click="bts()">
          <p>提交</p>
        </div>
        </form>
       
       
      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        forms:{
          famlyNames:'卢',
          Names:'',
          Eml:'',
          Phones:'',
          Texts:""
        },
        famlyNames:'',
        
      }
    },
    methods:{
      bts(){
        console.log(this.forms)
        // console.log(this.forms.famlyNames)
      }
    },
    created(){},
    mounted(){}
 }
</script>

<style scoped>
.tops{
  /* border: 5px solid red; */
  /* height: 70vh; */
  padding: 8rem 0;
  overflow: hidden;
  position: relative;
}
.tops img{
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.tops h2{
  font-size: 2.2rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  letter-spacing:0.5rem;
  text-indent: 0.5rem;
}
.boxs1{
  margin: 2.2rem 0;
}
.boxs1 p{
  margin: 1rem 0;
  text-align: center;
  line-height: 1.6;
  font-size: 0.8rem;
  color: #3b3c3c;
  }
  .boxs1 p span{
    color: red;
  }
  .boxs2{
    /* border: 1px solid red; */
    color: 0.6rem;
    margin: 3rem;
  }
  .boxs2 span{
    color: red;
  }
  .boxs2 p{
    font-size: 0.8rem;
    line-height: 2;
  }
  .boxs2 ul{

    box-sizing: border-box;

    padding: 1rem 4rem;
    width: 40%;
    margin: auto;
    background: #eee;
  }
  .boxs2 ul li{
    margin-bottom: 0.5rem;
  }
  .boxs2 input{
    width: 100%;
    outline: none;
    padding: 5px 10px;
    font-size: 0.6rem;
    height: 1.5rem;
    /* background-color: #eee; */
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 5px;
  }
  .boxs2 textarea{
    width: 100%;
    outline: none;
    padding: 5px 10px;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 5px;
    height: 120px;
    font-size: 0.6rem;
  }
  .btns{
    background: #2180D1;
    color: #F1F9F9;
    text-align: center;
    width: 45%;
    margin: auto;
  }
</style>